import { WLIDS } from 'Constants';
import { FormattedMessage } from 'react-intl';

import Skeleton from 'Views/Components/_HumanWritten/Skeleton/Skeleton';
import { NewModal } from 'Views/Components/Modal/NewModal';

export default function LoadingModal() {
	return (
		<>
			<NewModal.Header>
				<NewModal.Title>
					<FormattedMessage id={WLIDS.standby.modalTitle} defaultMessage="Join standby" />
				</NewModal.Title>
			</NewModal.Header>
			<NewModal.Body>
				<Skeleton height="10rem" width="100%" />
			</NewModal.Body>
			<NewModal.Footer>
				<NewModal.CancelButton disabled onClick={() => {}}>
					Close
				</NewModal.CancelButton>
				<NewModal.ConfirmButton disabled onClick={() => {}}>
					Confirm
				</NewModal.ConfirmButton>
			</NewModal.Footer>
		</>
	);
}
